export default __webpack_public_path__ + "static/media/4.33864b87.png";